import { render, staticRenderFns } from "./AdminSocietyTable.vue?vue&type=template&id=49c2b915&scoped=true"
import script from "./AdminSocietyTable.vue?vue&type=script&lang=js"
export * from "./AdminSocietyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c2b915",
  null
  
)

export default component.exports